'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var withWidth = require('../../node_modules/@material-ui/core/esm/withWidth/withWidth.js');

var isWidthUp = withWidth.isWidthUp;

exports.isWidthDown = withWidth.isWidthDown;
exports.isWidthUp = withWidth.isWidthUp;
exports["default"] = isWidthUp;
